import { Column } from '@ant-design/charts';
import styled from 'styled-components';

export const HistogramStyled = styled(Column)`
  width: 100%;
`;
